import { helper } from './helper';

export const type = helper.accessor('Type', {});
